import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    statsIsOpen: false,
};
const { actions, reducer } = createSlice({
    name: 'statsStatus',
    initialState,
    reducers: {
        setStatsOpen: (state, { payload }) => {
            state.statsIsOpen = payload;
        },
    },
});
export const { setStatsOpen } = actions;
export default reducer;
